<template>
  <div class="box">
    <div class="box-100-no-centered">
      <div class="box-b-nombre-cliente">
        <div id="dtBasicExample_filter" class="dataTables_filter">
          <label>
            Buscar:
            <input
              type="search"
              class="form-control form-control-sm"
              placeholder
              aria-controls="dtBasicExample"
              v-model="reportSearch"
            />
          </label>
        </div>
      </div>
      <div class="box-ver-cliente">
        <div class="dataTables_length bs-select" id="dtBasicExample_length">
          <label>
            Ver
            <select
              name="dtBasicExample_length"
              aria-controls="dtBasicExample"
              class="custom-select custom-select-sm form-control form-control-sm"
              v-model="selectedValue"
              @change="onChange($event)"
            >
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </label>
        </div>
      </div>
      <div class="ml-3 mt-4">
        <download-excel
          class="btn btn-success"
          :data="reports"
          :columns="columns"
          :filename="'report ' + new Date()"
          :sheetname="'reporte'"
        >Download</download-excel>
      </div>
    </div>
    <div class="box-100">
      <div class="box-table">
        <div class="overflow-auto">
          <div class="box-100">
            <div class="box-50">
              <label for="example-datepicker-init">Desde:</label>
              <b-form-datepicker id="example-datepicker-init" v-model="initDate" class="mb-2"></b-form-datepicker>
            </div>
            <div class="box-50">
              <label for="example-datepicker-final">Hasta:</label>
              <b-form-datepicker id="example-datepicker-final" v-model="currentDate" class="mb-2"></b-form-datepicker>
            </div>
          </div>
          <div>
            <b-button variant="primary" @click="onChangeDatePicker">Buscar</b-button>
          </div>
          <br />
          <b-pagination
            pills
            v-model="currentPage"
            :total-rows="getEntries"
            :per-page="selectedValue"
            aria-controls="my-table-report"
            size="md"
            align="center"
          ></b-pagination>
          <b-table
            id="my-table-report"
            show-empty
            small
            stacked="md"
            head-variant="dark"
            :current-page="currentPage"
            :per-page="selectedValue"
            :items="filteredReportList"
            :fields="fields"
          ></b-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getAllReports } from "./../../api/conection";
import moment from "moment-timezone";
export default {
  name: "ReportsList",
  components: {},
  /*
  props: {
    reports: {
      type: Array,
      default: [],
    },
    columns: {
      type: Array,
      default: [],
    },
  },
  */
  /*
  mounted() {
    getAllReports(this.initDate, this.currentDate)
      .then((response) => {
        if (response.status === 200)
          this.$store.dispatch("setReportsAction", response.body);
      })
      .catch((err) => {
        console.log(err);
      });
  },*/
  /*
  watch: {
    initDate: function (val) {
      this.onChangeDatePicker(val,this.currentDate)
    },
    currentDate: function (val) {
      this.onChangeDatePicker(this.initDate,final)
    }
  },*/
  computed: {
    filteredReportList() {
      /* 
      const list =
        this.reports.length > 0
          ? this.reports.filter(report => {
            debugger;
            /*
              return this.reportSearch !== ""
                ? report.username
                    .toLowerCase()
                    .includes(this.reportSearch.toLowerCase())
                : true;
            })
          : [];
          */
      const search = this.reportSearch.toLowerCase();
      const list =
        this.reports.filter(report => {
              let resp;
              if (search !== "") {
                //debugger;
                if (!report.username){
                  debugger
                }else{
                  resp = report.username.toLowerCase().includes(search);
                }
              } else {
                resp = true;
              }
              return resp;
            });

      this.paginationLength = list.length;
      return list;
    },
    getEntries() {
      return this.paginationLength;
    },
  },
  data() {
    return {
      reportSearch: "",
      reports: [],
      columns: [],
      currentPage: 1,
      selectedValue: 10,
      paginationLength: 0,
      initDate: moment()
        .tz("America/Argentina/Buenos_Aires")
        .format("YYYY-MM-DD"),
      currentDate: moment()
        .tz("America/Argentina/Buenos_Aires")
        .format("YYYY-MM-DD"),
      fields: [
        { label: "Hora", key: "hora", sortable: true },
        { label: "Dia", key: "dia", sortable: true },
        { label: "Username", key: "username", sortable: true },
        { label: "Score", key: "score", sortable: true },
        { label: "Pregunta", key: "pregunta", sortable: true },
        { label: "Respuesta", key: "respuesta", sortable: true },
      ],
    };
  },
  methods: {
    mostrar(value) {
      console.log(value);
    },
    onChange(event) {
      console.log(event.target.value);
    },
    onChangeDatePicker() {
      getAllReports(this.initDate, this.currentDate)
        .then((response) => {
          if (response.status === 200)
            //this.$store.dispatch("setReportsAction", response.body);
            this.reports = response.body.reports;
            this.columns = response.body.columns;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>